import { Cancel as CrossIcon } from '@mui/icons-material';
import { Box, Card, CircularProgress, Typography } from '@mui/material';
import React from 'react';
import { StyledCheckbox } from '../../styles/StyledInputs';
import { WizardDocumentStatus } from './aiAssistedCreationWizardTypes';

interface DocumentStatusCardProps {
  doc: WizardDocumentStatus;
  isSelected: boolean;
  onSelectionChange: (doc: WizardDocumentStatus, checked: boolean) => void;
}

export const DocumentStatusCard: React.FC<DocumentStatusCardProps> = ({
  doc,
  isSelected,
  onSelectionChange,
}) => {
  const isActive = doc.status === 'active';
  const isPending = doc.status === 'pending';
  const isError = !isActive && !isPending;
  const statusLabel = isActive ? 'Ready' : isPending ? 'Checking...' : 'Expired';

  return (
    <Card
      sx={{
        minWidth: 140,
        maxWidth: 260,
        width: 'calc(33% - 8px)',
        border: '1px solid',
        borderColor: isError ? 'error.main' : isActive ? 'success.main' : 'divider',
        backgroundColor: isError ? 'error.light' : isActive ? 'success.light' : 'background.paper',
        padding: '0.5rem 0.75rem',
        boxSizing: 'border-box',
        '& .MuiCardContent-root': {
          padding: '0 !important',
        },
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
        <Box
          sx={{
            width: 20,
            height: 20,
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            minWidth: 20,
            flexShrink: 0,
            backgroundColor: isError ? 'error.main' : isActive ? 'success.main' : 'transparent',
            color: 'white',
            fontSize: '0.625rem',
          }}
        >
          {isPending ? (
            <CircularProgress size={16} thickness={4} />
          ) : isActive ? (
            '✓'
          ) : (
            <CrossIcon sx={{ fontSize: '0.875rem' }} />
          )}
        </Box>
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography
            variant="caption"
            sx={{
              fontWeight: 600,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              display: 'block',
            }}
          >
            {doc.name}
          </Typography>
          <Typography variant="caption" sx={{ fontSize: '0.65rem', opacity: 0.8 }}>
            {statusLabel}
          </Typography>
        </Box>
        {isActive && (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.25 }}>
            <StyledCheckbox
              checked={isSelected}
              onChange={(e) => onSelectionChange(doc, e.target.checked)}
              sx={{ p: 0.25 }}
            />
            <Typography variant="caption" sx={{ fontSize: '0.65rem' }}>
              Use
            </Typography>
          </Box>
        )}
      </Box>
    </Card>
  );
};
